import { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { account } from '../api/client';

const TYPE = { FULL_TIME: 'Full time', PART_TIME: 'Part time', CONTRACT: 'Contract', INTERN: 'Intern', CONSULTANT: 'Consultant' };

function fmtDate(iso) {
  if (!iso) return '—';
  const [y, m, d] = String(iso).slice(0, 10).split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
}

/** The signed-in employee's own record, read-only - HR corrects anything wrong. */
export default function ProfileDialog({ me, onClose }) {
  const [emp, setEmp] = useState(null);
  const [managerName, setManagerName] = useState(null);
  const [failed, setFailed] = useState(null);

  useEffect(() => {
    let live = true;
    account.profile().then((p) => {
      if (!live) return;
      setEmp(p.employee);
      setManagerName(p.managerName);
    }).catch((e) => { if (live) setFailed(e.message); });
    return () => { live = false; };
  }, [me.employeeId]);

  const rows = emp ? [
    ['Employee code', emp.employeeCode],
    ['Designation', emp.designation && emp.designation.title],
    ['Department', emp.department && emp.department.name],
    ['Reports to', managerName],
    ['Work email', emp.workEmail],
    ['Phone', emp.phone],
    ['Employment', TYPE[emp.employmentType] || emp.employmentType],
    ['Joined', fmtDate(emp.dateOfJoining)],
    ['Location', emp.workLocation],
  ] : [];

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ pb: 0.5 }}>{me.name}</DialogTitle>
      <DialogContent>
        {failed ? (
          <Typography sx={{ fontSize: 13.5, color: 'error.main', py: 2 }}>{failed}</Typography>
        ) : !emp ? (
          <Box sx={{ display: 'grid', placeItems: 'center', py: 4 }}><CircularProgress size={26} /></Box>
        ) : (
          <>
            <Box component="dl" sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr', columnGap: 2, rowGap: 1, m: 0, mt: 1 }}>
              {rows.map(([k, v]) => (
                <Box key={k} sx={{ display: 'contents' }}>
                  <Typography component="dt" sx={{ fontSize: 13, color: 'text.secondary' }}>{k}</Typography>
                  <Typography component="dd" sx={{ fontSize: 13.5, m: 0, fontWeight: 550, wordBreak: 'break-word' }}>{v || '—'}</Typography>
                </Box>
              ))}
            </Box>
            <Typography sx={{ fontSize: 12.5, color: 'text.secondary', mt: 2.5 }}>
              Something wrong here? Ask HR to correct it.
            </Typography>
          </>
        )}
      </DialogContent>
      <DialogActions><Button onClick={onClose}>Close</Button></DialogActions>
    </Dialog>
  );
}
